module.exports = __webpack_public_path__ + "img/vol06_character_name2.e88a54b5.png";